<template>
  <v-app-bar
    :app="app"
    flat
    dense
    :fixed="fixed"
    :height="height"
    :extension-height="extensionHeight"
    :title="getTitle"
    :dark="dark || hideBackground"
    :color="hideBackground ? 'transparent' :  color"
    class="content-header"
    :style="{ '--system-bar-color': `${hideBackground ? 'transparent' :  color}` }"
  >
    <slot name="start">
      <v-btn v-if="!isHideBack"
             icon plain :ripple="false"
             class="btn-page-prev"
             @click="onClickBack()">
        <IconBack />
      </v-btn>
    </slot>
    <v-toolbar-title>{{ getTitle }}</v-toolbar-title>
    <v-spacer />
    <slot v-if="helpContent" name="helpContent">
      <Exclamation @open="open()"/>
    </slot>
    <slot name="end" @close="close">
    </slot>
    <template #extension v-if="$slots.default">
      <slot></slot>
    </template>
  </v-app-bar>
</template>

<script>
import IconBack from '@/components/icons/Back'
import Exclamation from '../icons/Exclamation3';
export default {
  components: {
    IconBack,
    Exclamation
  },
  props: {
    // v-main padding-top 에 영향을 주는지 여부
    app: {
      type: Boolean,
      default: true
    },
    fixed: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: '56px'
    },
    // title 영역 아래에 생기는 여분의 height
    extensionHeight: {
      type: String,
      default: '0'
    },
    hideBack: {
      type: Boolean,
      default: false
    },
    hideBackground: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'white'
    },
    helpContent: {
      type: Boolean,
      default: false
    },
    back: Function,
    close: Function
  },
  data: () => ({
  }),
  computed: {
    getTitle () {
      if (this.title) return this.title
      return this.$route.meta.headerTitle
    },
    isHideBack () {
      if (this.hideBack) return this.hideBack
      return this.$route.meta.isHideBack;
    },
    isMainBack () {
      return this.$route.meta.isMainBack;
    }
  },
  created () {
  },
  methods: {
    onClickBack () {
      if (this.back) this.back()
      else this.prevPage()
    },
    open () {
      this.$emit('helpContentOpen')
    }
  }
}
</script>
